<template>
  <li
    :class="classes"
    role="treeitem"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <router-link
      v-if="!hasSubItems"
      v-text="text"
      :to="path"
    >
    </router-link>
    <a
      v-else
      v-text="text"
    >
    </a>
    <slot/>
  </li>
</template>

<script>
export default {
  name: 'NavigationMobileItem',
  props: {
    text: String,
    path: String,
    isSubMenuItem: Boolean,
    hasSubItems: Boolean
  },
  computed: {
    classes: function () {
      const classes = [];
      if (!this.isSubMenuItem) {
        if (this.hasSubItems) {
          classes.push('is-drilldown-submenu-parent');
        } else {
          classes.push('top-level-link-container');
        }
        return classes;
      }
      classes.push('is-submenu-item', 'is-drilldown-submenu-item');
      return classes;
    }
  }
};
</script>
